(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamsa-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__lamsaReviewsCarousel) {
      window.__lamsaReviewsCarousel.initAll(document);
      return;
    }

    function initLamsaReviews(section) {
      var track = section.querySelector('[id^="lamsa-reviews-track-"]');
      var strip = section.querySelector('[id^="lamsa-reviews-strip-"]');
      if (!track || !strip) return;

      if (section.dataset.lamsaReviewsInit === 'true') return;
      section.dataset.lamsaReviewsInit = 'true';

      var speed = (parseFloat(section.dataset.scrollSpeed) || 35) / 100;
      var offset = 0;
      var paused = false;
      var loopWidth = 0;
      var originals = Array.from(strip.children).filter(function (cell) {
        return !cell.dataset.clone;
      });

      if (!originals.length) return;

      function buildStrip() {
        Array.from(strip.children).forEach(function (cell) {
          if (cell.dataset.clone) cell.remove();
        });

        var originalWidth = originals.reduce(function (sum, cell) {
          return sum + cell.offsetWidth;
        }, 0);

        if (!originalWidth) return;

        var setsNeeded = Math.ceil((track.offsetWidth + originalWidth) / originalWidth) + 1;
        for (var s = 0; s < setsNeeded; s++) {
          originals.forEach(function (cell) {
            var clone = cell.cloneNode(true);
            clone.dataset.clone = '1';
            clone.removeAttribute('id');
            strip.appendChild(clone);
          });
        }

        loopWidth = originalWidth;
      }

      function updateSpotlight() {
        var trackRect = track.getBoundingClientRect();
        var centerX = trackRect.left + trackRect.width / 2;
        var cells = strip.querySelectorAll('.lamsa-reviews__cell');
        var closest = null;
        var closestDist = Infinity;

        cells.forEach(function (cell) {
          var rect = cell.getBoundingClientRect();
          var cellMid = rect.left + rect.width / 2;
          var dist = Math.abs(cellMid - centerX);
          if (dist < closestDist) {
            closestDist = dist;
            closest = cell;
          }
        });

        cells.forEach(function (cell) {
          cell.classList.toggle('is-selected', cell === closest);
        });
      }

      function onResize() {
        offset = 0;
        strip.style.transform = 'translateX(0)';
        buildStrip();
        updateSpotlight();
      }

      buildStrip();
      window.addEventListener('resize', onResize);
      track.addEventListener('mouseenter', function () {
        paused = true;
      });
      track.addEventListener('mouseleave', function () {
        paused = false;
      });

      function tick() {
        if (!paused && loopWidth > 0) {
          offset += speed;
          if (offset >= loopWidth) offset -= loopWidth;
          strip.style.transform = 'translateX(-' + offset + 'px)';
          updateSpotlight();
        }
        requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-lamsa-reviews]').forEach(initLamsaReviews);
    }

    window.__lamsaReviewsCarousel = { initAll: initAll };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
